import {LocaleType} from '@toolify/server/src/services/UserSettingsService/strategies/LocaleUserSettingStrategy/enum/LocaleType'
import {ILocaleTypeItem} from '@toolify/client/src/modules/internalization/types/ILocaleTypeItem'

export const LocaleTypeItems: ILocaleTypeItem[] = [
  {
    localeType: LocaleType.English,
    title: 'English',
    flagAlphaCode: 'gb',
  },
  {
    localeType: LocaleType.Polish,
    title: 'Polski',
    flagAlphaCode: 'pl',
  },
  {
    localeType: LocaleType.Ukrainian,
    title: 'Українська',
    flagAlphaCode: 'ua',
  },
  {
    localeType: LocaleType.German,
    title: 'Deutsch',
    flagAlphaCode: 'de',
  },
  {
    localeType: LocaleType.French,
    title: 'Français',
    flagAlphaCode: 'fr',
  },
  {
    localeType: LocaleType.Spanish,
    title: 'Español',
    flagAlphaCode: 'es',
  },
  {
    localeType: LocaleType.Italian,
    title: 'Italiano',
    flagAlphaCode: 'it',
  },
  {
    localeType: LocaleType.Portuguese,
    title: 'Português',
    flagAlphaCode: 'pt',
  },
  {
    localeType: LocaleType.Dutch,
    title: 'Nederlands',
    flagAlphaCode: 'nl',
  },
  {
    localeType: LocaleType.Swedish,
    title: 'Svenska',
    flagAlphaCode: 'se',
  },
  {
    localeType: LocaleType.Norwegian,
    title: 'Norsk',
    flagAlphaCode: 'no',
  },
  {
    localeType: LocaleType.Danish,
    title: 'Dansk',
    flagAlphaCode: 'dk',
  },
  {
    localeType: LocaleType.Finnish,
    title: 'Suomi',
    flagAlphaCode: 'fi',
  },
  {
    localeType: LocaleType.Greek,
    title: 'Ελληνικά',
    flagAlphaCode: 'gr',
  },
  {
    localeType: LocaleType.Turkish,
    title: 'Türkçe',
    flagAlphaCode: 'tr',
  },
  {
    localeType: LocaleType.Japanese,
    title: '日本語',
    flagAlphaCode: 'jp',
  },
  {
    localeType: LocaleType.Chinese,
    title: '中文',
    flagAlphaCode: 'cn',
  },
  {
    localeType: LocaleType.Korean,
    title: '한국어',
    flagAlphaCode: 'kr',
  },
  {
    localeType: LocaleType.Arabic,
    title: 'العربية',
    flagAlphaCode: 'sa',
  },
]
